"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _Skeleton = require("./Skeleton.styles");

var Item = (0, _base["default"])("span", {
  target: "e17x4mye0",
  label: "Item"
})(_Skeleton.styles.skeletonItem, ";");

var Skeleton = function Skeleton(_ref) {
  var count = _ref.count,
      duration = _ref.duration,
      className = _ref.className,
      width = _ref.width,
      height = _ref.height,
      isCircle = _ref.isCircle,
      isText = _ref.isText;
  return (0, _toConsumableArray2["default"])(Array(count)).map(function (_, index) {
    return (0, _jsxRuntime.jsx)(Item, {
      duration: duration // eslint-disable-next-line react/no-array-index-key
      ,
      className: className,
      isCircle: isCircle,
      isText: isText,
      style: {
        width: width,
        height: height
      },
      children: "\u200C"
    }, index);
  });
};

Skeleton.propTypes = {
  count: _propTypes.number,
  duration: _propTypes.number,
  height: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]),
  width: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]),
  isCircle: _propTypes.bool,

  /**
   * Show inline-block skeleton, which will add spacing automatically
   * by use its container's line-height and font-size
   */
  isText: _propTypes.bool
};
Skeleton.defaultProps = {
  count: 1,
  duration: 1.2,
  height: undefined,
  width: undefined,
  circle: false,
  className: undefined,
  isCircle: false,
  isText: false
};
var _default = Skeleton;
exports["default"] = _default;
//# sourceMappingURL=Skeleton.js.map